/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row2_ModelInputs */

const en_mk_model_row2_model = /** @type {(inputs: Mk_Model_Row2_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creative model (Fable 5)`)
};

const id_mk_model_row2_model = /** @type {(inputs: Mk_Model_Row2_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model kreatif (Fable 5)`)
};

/**
* | output |
* | --- |
* | "Creative model (Fable 5)" |
*
* @param {Mk_Model_Row2_ModelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row2_model = /** @type {((inputs?: Mk_Model_Row2_ModelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row2_ModelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row2_model(inputs)
	return en_mk_model_row2_model(inputs)
});